export default __webpack_public_path__ + "static/media/scenario-designer.f7659d8b.png";